export const sessionRecordingTypes = [
    'NONE',
    'VIDEO',
    'TEXT',
    'BOTH'
];

export const sessionRecordingTypeLabel = sessionRecordingType => ({
    NONE: 'company.manage-application.configuration.session-recording.recording-type.none',
    VIDEO: 'company.manage-application.configuration.session-recording.recording-type.video',
    TEXT: 'company.manage-application.configuration.session-recording.recording-type.text',
    BOTH: 'company.manage-application.configuration.session-recording.recording-type.both',
})[sessionRecordingType];



// WEBPACK FOOTER //
// ./src/portal/components/sp-session-recording-type/sp-session-recording-type.enum.js